import { Text } from '@sparemin/blockhead';
import cn from 'classnames';
import MailtoSupport from 'components/MailtoSupport';
import React from 'react';
import styles from './TldlSupportBanner.module.scss';

export type TldlSupportBannerProps = {
  className?: string;
};

const TldlSupportBanner: React.FC<TldlSupportBannerProps> = ({ className }) => (
  <Text
    className={cn(styles.root, className)}
    letterSpacing={0.28}
    size="14px"
    variant="p"
    weight={400}
  >
    Have questions about your podcast on TL;DL? <MailtoSupport />
  </Text>
);

export default TldlSupportBanner;
